// API URLs
export const API_GATEWAY_URL = 'https://ve4940h8ea.execute-api.us-east-1.amazonaws.com/prod';
export const APPSYNC_URL = 'https://cfliiybhtzgjzglr5qzhp3duyi.appsync-api.us-east-1.amazonaws.com/graphql';
export const APPSYNC_REGION = 'us-east-1';

// Application constants
export const EARLIEST_WORD_DATE_MAP: { [key: string]: string } = {
  'Arabic': '2025-05-31',
  'English': '2025-07-01'
};

// Get earliest word date for current language
export const getEarliestWordDate = (): string => {
  const language = getCurrentLanguage();
  return EARLIEST_WORD_DATE_MAP[language] || '2025-05-31';
};

// Language mapping based on subdomain
export const SUBDOMAIN_LANGUAGE_MAP: { [key: string]: string } = {
  'arabic-word': 'Arabic',
  'english-word': 'English'
};

// Language override for localhost testing
export const LANGUAGE_OVERRIDE = process.env.REACT_APP_LANGUAGE_OVERRIDE;

// Get current language based on hostname
export const getCurrentLanguage = (): string => {
  // Check for override first (for localhost testing)
  if (LANGUAGE_OVERRIDE) {
    return LANGUAGE_OVERRIDE;
  }
  
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];
  return SUBDOMAIN_LANGUAGE_MAP[subdomain] || 'Arabic';
};

// AWS Cognito Config
export const COGNITO_CONFIG = {
  identityPoolId: 'us-east-1:af7967b5-89ad-46e0-822a-ef7fdaa2a7de', // Replace with actual Identity Pool ID after deployment
  region: APPSYNC_REGION,
};

// GraphQL Queries
export const GET_WORD_OF_THE_DAY_QUERY = `
  query GetWordOfTheDay($date: String, $wordLanguage: String) {
    getWordOfTheDay(date: $date, wordLanguage: $wordLanguage) {
      id
      translation
      word
      romanization
      audioUrl
      example
      displayDate
    }
  }
`;

export const GET_RANDOM_WORDS_QUERY = `
  query GetRandomWords($startDate: String!, $wordLanguage: String) {
    getRandomWords(startDate: $startDate, wordLanguage: $wordLanguage) {
      id
      translation
      word
      romanization
      displayDate
      audioUrl
    }
  }
`;

// Single word lookup by URL slug, used by the /{slug} deep-link route.
export const GET_WORD_BY_SLUG_QUERY = `
  query GetWordBySlug($slug: String!, $wordLanguage: String) {
    getWordBySlug(slug: $slug, wordLanguage: $wordLanguage) {
      id
      translation
      word
      romanization
      audioUrl
      example
      displayDate
      slug
    }
  }
`;

// Local Storage Keys
export const GOOGLE_TOKEN_KEY = 'google_token';

// HTTP Headers
export const DEFAULT_HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};